export default function getDaysDifference (fromDate, toDate) {
  const oneDay = 24 * 60 * 60 * 1000

  return Math.round(Math.abs((fromDate - toDate) / oneDay))
} 